import Meta from "./../components/Meta";
import { useRouter } from "../util/router";
import Button from "react-bootstrap/Button";
import { useAuth } from "../util/auth";
import { useState, useEffect } from "react";
import {
  useEventDivisions,
  useEventSideGames,
  useUsersName,
  // useUsersSchool,
} from "../util/db";
import Container from "react-bootstrap/Container";
import SectionHeader from "../components/SectionHeader";
import { requireAuth } from "./../util/auth";
import PromptUsersNameForm from "../components/PromptUsersNameForm";
import { ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { registerPlayerForEvent } from "../util/registration";
import Spinner from "react-bootstrap/Spinner";
// import PromptUsersSchoolForm from "../components/PromptUsersSchoolForm";

function RegisterPage(props) {
  const router = useRouter();
  const auth = useAuth();
  const uid = auth.user ? auth.user.uid : undefined;
  const numThrows = 2; //number of throws per hole

  //state
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedSideGames, setSelectedSideGames] = useState([]);
  const [isRegistering, setIsRegistering] = useState(false);

  //for users name
  const {
    data: usersName = [],
    status: usersNameStatus,
    // error: usersNameError,
  } = useUsersName(uid);

  //for users school
  // const {
  //   data: usersSchool,
  //   // status: usersSchoolStatus,
  //   // error: usersSchoolError,
  // } = useUsersSchool(uid);

  //for users phone
  // const {
  // data: usersPhone = [],
  // status: usersPhoneStatus,
  // error: usersPhoneError,
  // } = useUsersPhone(uid);
  //signupstate object
  const [signupObject, setSignupObject] = useState({
    event_divisions_id: null,
    division_name: "",
    division_cost: 0,
    side_games: [],
    side_games_cost: 0,
    event_id: null, // Initialize as null, will be set in useEffect
    user_id: uid,
    layout_id: null,
  });

  // Update signupObject when router.query.id becomes available
  useEffect(() => {
    if (router.query.id && signupObject.event_id !== router.query.id) {
      setSignupObject((prev) => ({
        ...prev,
        event_id: router.query.id,
      }));
    }
  }, [router.query.id, signupObject.event_id]);

  //get divisions
  const {
    data: items,
    status: itemsStatus,
    // error: itemsError,
  } = useEventDivisions(router.query.id);

  //get side games
  const {
    data: sideGames,
    status: sideGamesStatus,
    // error: sideGamesError
  } = useEventSideGames(router.query.id);

  //totalcharge state
  // const [totalCharge,setTotalCharge] = useState(signupObject.division_cost + signupObject.side_games_cost)

  //set division
  const handleSetDivision = (
    event_divisions_id,
    division_cost,
    division_name,
    layout_id
  ) => {
    //set division state
    setSelectedDivision(event_divisions_id);

    //set overall state object
    //copy signup object
    const newSignupObject = { ...signupObject };

    //copy new division and cost to new object
    newSignupObject.event_divisions_id = event_divisions_id;
    newSignupObject.division_cost = division_cost;
    newSignupObject.division_name = division_name;
    newSignupObject.layout_id = layout_id;

    //0verwrite existing signupobject
    setSignupObject(newSignupObject);

    //update total charge state
    // setTotalCharge(signupObject.division_cost + signupObject.side_games_cost)
  };

  //set side game
  const handleSetSideGame = (new_side_game, side_game_charge) => {
    //use side game state
    //copy side games object and add new side game
    const newSelectedSideGames = [...selectedSideGames, new_side_game];

    // set state to new object
    setSelectedSideGames(newSelectedSideGames);

    //use full object
    //copy signup object
    const newSignupObject = { ...signupObject };

    //add side game to array
    newSignupObject.side_games.push(new_side_game);
    newSignupObject.side_games_cost += side_game_charge;

    //0verwrite existing signupobject
    setSignupObject(newSignupObject);

    //update total charge state
    // setTotalCharge(signupObject.division_cost + signupObject.side_games_cost)
  };

  // unset side game
  const handleUnsetSideGame = (remove_side_game, remove_side_game_cost) => {
    //use side game state
    const newSelectedSideGames = [...selectedSideGames];

    if (newSelectedSideGames.includes(remove_side_game)) {
      newSelectedSideGames.splice(
        newSelectedSideGames.indexOf(remove_side_game),
        1
      );
    }

    setSelectedSideGames(newSelectedSideGames);

    //use full object
    //copy signup object
    const newSignupObject = { ...signupObject };

    //remove side game from array
    const index = newSignupObject.side_games.indexOf(remove_side_game);
    if (index > -1) {
      newSignupObject.side_games.splice(index, 1);
    }

    //remove cost of side game from charge
    newSignupObject.side_games_cost -= remove_side_game_cost;

    //0verwrite existing signupobject
    setSignupObject(newSignupObject);

    //update total charge state
    // setTotalCharge(signupObject.division_cost + signupObject.side_games_cost)
  };

  //return true if this is the selected division
  const isSelectedDivision = (this_event_divisions_id) => {
    if (selectedDivision === this_event_divisions_id) {
      return true;
    } else {
      return false;
    }
  };

  //return true if this is the selected sidegame
  const isSelectedSideGame = (this_sidegame_id) => {
    if (selectedSideGames.includes(this_sidegame_id)) {
      return true;
    } else {
      return false;
    }
  };
  const handleRegisterClick = async () => {
    if (signupObject.event_divisions_id === null) {
      alert("Please select a division");
      return;
    }

    if (!usersName || usersName.length === 0) {
      alert("Please save your name before proceeding.");
      return;
    }

    // Wait a moment for layout_id if division is selected but layout_id is still loading
    if (!signupObject.layout_id && signupObject.event_divisions_id) {
      // Give it a short delay to allow data to load
      setTimeout(() => {
        if (!signupObject.layout_id) {
          alert(
            "Please wait for division data to load completely, then try again."
          );
        }
      }, 100);
      return;
    }

    setIsRegistering(true);

    try {
      await registerPlayerForEvent({
        event_id: signupObject.event_id,
        user_id: signupObject.user_id,
        event_divisions_id: signupObject.event_divisions_id,
        layout_id: signupObject.layout_id,
        numThrows: numThrows,
      });

      // Navigate to event page
      router.push(`/event?event=${signupObject.event_id}`);
    } catch (err) {
      console.error("Error during registration:", err);
      alert("An error occurred during registration. Please try again.");
      setIsRegistering(false);
    }
  };

  // const checkForSchool = () => {
  //   if (usersSchool && usersSchool.length > 0 && usersSchool[0].schools) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  //useeffect to make totalcharge work
  // useEffect(() => {
  //   // Update the document title using the browser API
  //   const $thistotalcost = signupObject.division_cost + signupObject.side_games_cost
  //   setTotalCharge("Total Charge: $" +  $thistotalcost )
  // },[signupObject]);

  return (
    <>
      <Meta title="Signup" />
      <Container>
        <div className="text-right mt-1">
          <Link to={`/event?event=${router.query.id}`}>Back to Event</Link>
        </div>
        <SectionHeader
          title="Choose Your Division"
          subtitle="Then, click confirm"
          size={1}
          spaced={true}
          className="text-center mt-3 mb-3"
        />
      </Container>
      {/* {checkForPhone() ? <center><h6>Phone Number: {usersPhone[0].phonenumber} </h6></center> : <PromptUsersPhoneForm uid={uid} />} */}
      {/* </Section> */}
      {/* //if users name lookup returns no result, show form. However, if the usersName lookup has not finished yet, do not show form
      // usersName.length === 0 && */}
      {usersNameStatus !== "loading" && usersName.length === 0 && (
        <PromptUsersNameForm uid={uid} />
      )}
      {usersNameStatus !== "loading" && usersName.length > 0 && (
        <Container>
          <h6>Name: {usersName[0].name}</h6>
        </Container>
      )}

      {/* Note: Make so school must be selected before clicking confirm. See solution for players name in onregisterclick */}
      {/* {checkForSchool() ? (
        <Container>
          <h6>School: {usersSchool[0].schools.name}</h6>
        </Container>
      ) : (
        <PromptUsersSchoolForm uid={uid} />
      )} */}

      <Container className="mb-3">
        <ListGroup as="ul">
          {itemsStatus !== "loading" &&
            items &&
            items.length > 0 &&
            items.map((item, index) =>
              isSelectedDivision(item.event_divisions_id) ? (
                <ListGroup.Item
                  as="li"
                  key={index}
                  active
                  style={{ background: "#2D083F" }}
                >
                  <p
                    className="font-weight-bold mb-0"
                    style={{ color: "white" }}
                  >
                    {item.divisions.name}
                  </p>
                </ListGroup.Item>
              ) : (
                <ListGroup.Item
                  as="li"
                  key={index}
                  onClick={() => {
                    handleSetDivision(
                      item.event_divisions_id,
                      item.division_cost,
                      item.divisions.name,
                      item.layout_id
                    );
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <p className="font-weight-bold mb-0">{item.divisions.name}</p>
                </ListGroup.Item>
              )
            )}
        </ListGroup>
      </Container>
      {/* side game section */}
      {sideGamesStatus !== "loading" && sideGames && sideGames.length > 0 && (
        <Container className="mb-3">
          <SectionHeader
            title="Choose Side Games"
            subtitle="Optional - Select any side games you'd like to participate in"
            size={2}
            spaced={true}
            className="text-center mt-3 mb-3"
          />
          <ListGroup as="ul">
            {sideGames.map((sideGame, index) =>
              isSelectedSideGame(sideGame.id) ? (
                <ListGroup.Item
                  as="li"
                  key={index}
                  active
                  style={{ background: "#2D083F", cursor: "pointer" }}
                  onClick={() =>
                    handleUnsetSideGame(sideGame.id, sideGame.side_game_price)
                  }
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <p
                      className="font-weight-bold mb-0"
                      style={{ color: "white" }}
                    >
                      {sideGame.side_game_name}
                    </p>
                    <p
                      className="font-weight-bold mb-0"
                      style={{ color: "white" }}
                    >
                      ${sideGame.side_game_price}
                    </p>
                  </div>
                </ListGroup.Item>
              ) : (
                <ListGroup.Item
                  as="li"
                  key={index}
                  onClick={() =>
                    handleSetSideGame(sideGame.id, sideGame.side_game_price)
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="font-weight-bold mb-0">
                      {sideGame.side_game_name}
                    </p>
                    <p className="font-weight-bold mb-0">
                      ${sideGame.side_game_price}
                    </p>
                  </div>
                </ListGroup.Item>
              )
            )}
          </ListGroup>
        </Container>
      )}
      {/* <h5 style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>{totalCharge}</h5> */}
      <Container className="mb-4">
        <div className="d-grid gap-2">
          <Button
            variant={props.buttonColor}
            size="lg"
            onClick={handleRegisterClick}
            disabled={
              isRegistering ||
              itemsStatus === "loading" ||
              !signupObject.layout_id ||
              signupObject.event_divisions_id === null ||
              !usersName ||
              usersName.length === 0
            }
            className="py-3"
          >
            {/* Confirm! */}
            {isRegistering ? (
              <Spinner
                animation="border"
                size="sm"
                role="status"
                aria-hidden={true}
                className="align-baseline"
              >
                <span className="sr-only">Loading...</span>
              </Spinner>
            ) : itemsStatus === "loading" ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden={true}
                  className="align-baseline me-2"
                />
                Loading divisions...
              </>
            ) : !signupObject.layout_id && signupObject.event_divisions_id ? (
              "Loading ..."
            ) : (
              "Confirm!"
            )}
          </Button>
        </div>
      </Container>
    </>
  );
}

export default requireAuth(RegisterPage);
